import { createContext } from "react";
import type { PricesDisplay } from "src/api/organizations/queryPreferences";
import type { UseCalendarFilterValue } from "src/components/Filters/hooks";
import type { UseComparePeriodsFilterValue } from "src/components/Filters/hooks/useComparePeriodsFilter.hooks";
import type { VisibilityFilter } from "src/types/visibility/VisibilityFilter";
import type { UseDashboardFilterValue } from "src/views-ds/dashboard/dashboard-view/filters/useDashboardFilter.hooks";
import type { UseOfferDashboardFilterValue } from "src/views-ds/offer/hooks/useOfferDashboardFilters.hooks";
import type { UseSponsoredAdDashboardFilterValue } from "src/views-ds/sponsored-ad/hooks/useSponsoredAdDashboardFilters.hook";
import type { RevenueBreakdown } from "src/views-ds/dashboard/types";
import { type SettingsContextValue, SettingsProvider } from "./SettingsContext";

export interface SessionSettings {
    rankingVisibilityFilters?: VisibilityFilter;
    offerPlanningCalendar?: UseCalendarFilterValue;
    offerManagementCalendar?: UseCalendarFilterValue;
    offerPerformanceCalendar?: UseCalendarFilterValue;
    offerDetailCalendar?: UseCalendarFilterValue;
    sponsoredAdsPlanningCalendar?: UseCalendarFilterValue;
    sponsoredAdsManagementCalendar?: UseCalendarFilterValue;
    sponsoredAdsPerformanceCalendar?: UseCalendarFilterValue;
    sponsoredAdsDetailCalendar?: UseCalendarFilterValue;
    dashboardFilters?: UseDashboardFilterValue;
    offerDashboardFilters?: UseOfferDashboardFilterValue;
    sponsoredAdsDashboardFilters?: UseSponsoredAdDashboardFilterValue;
    welcomePageFilters?: UseComparePeriodsFilterValue;
    pricesDisplay?: PricesDisplay;
    revenueBreakdown?: RevenueBreakdown;
}

export type SessionSettingsKeys = keyof SessionSettings;

const DEFAULT_SETTINGS: SessionSettings = {
    pricesDisplay: "inclvat",
};

export const SessionSettingsContext = createContext<SettingsContextValue<SessionSettings>>({
    settings: DEFAULT_SETTINGS,
    clearSettings: () => {
        // RAF
    },
    saveSettings: () => {
        // RAF;
    },
    setUserInfos: () => {
        // RAF;
    },
});

interface SessionSettingsProviderProps {
    children: React.ReactNode;
}

export function SessionSettingsProvider({ children }: SessionSettingsProviderProps): JSX.Element {
    return (
        <SettingsProvider<SessionSettings>
            Context={SessionSettingsContext}
            storageManager={window.sessionStorage}
            defaultSettings={DEFAULT_SETTINGS}
        >
            {children}
        </SettingsProvider>
    );
}
